import { createFileRoute } from "@tanstack/react-router";
import { RequirePermission } from "@/currentUser/RequirePermission";
import { EmployeesPage } from "@/employees/EmployeesPage";
import { parseEmployeesSearch } from "@/employees/employeesSearch";

export const Route = createFileRoute("/_authenticated/employees")({
  validateSearch: parseEmployeesSearch,
  component: () => (
    <RequirePermission
      permission="admin_employee_read"
      fallback={<p>Je hebt geen toegang tot medewerkers.</p>}
    >
      <EmployeesPage />
    </RequirePermission>
  ),
});
